<template>
  <div>
    <v-dialog
      v-model="convertToOrderModal"
      persistent
      max-width="600px"
    >
      <v-card>
        <form @submit.prevent="submitForm()">
          <v-card-title class="pb-0">
            <v-flex
              xs11
              sm10
              md10
            >
              <span class="headline">
                {{ $t('orders.convertToOrderTitle') }}
              </span>
            </v-flex>
            <v-flex
              xs1
              sm2
              md2
            >
              <v-btn
                flat
                @click="closeDialog()"
                class="close"
              >
                <span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span>
              </v-btn>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-layout wrap>
              <v-flex
                xs12
                class="px-2"
              >
                <v-select
                  autocomplete
                  :items="customers"
                  item-value="value"
                  v-model="formData.customer_id_fk"
                  :error-messages="errors.collect('customer')"
                  data-vv-name="customer"
                  :label="$t('columns.customer') + '*'"
                  v-validate="'required'"
                />
              </v-flex>

              <v-flex
                xs12
                class="px-2"
              >
                <v-text-field
                  :label="$t('columns.productName') + ' *'"
                  v-model="formData.product_name"
                  :error-messages="errors.collect('Product Name')"
                  v-validate="'required'"
                  data-vv-name="Product Name"
                />
              </v-flex>

              <v-flex
                xs12
                sm6
                md6
                class="px-2"
              >
                <v-select
                  :items="warehouses"
                  item-value="value"
                  v-model="formData.warehouse_id_fk"
                  :error-messages="errors.collect('warehouse_id_fk')"
                  data-vv-name="warehouse_id_fk"
                  :label="$t('columns.warehouse') + '*'"
                  v-validate="'required'"
                />
              </v-flex>

              <v-flex
                xs12
                sm6
                md6
                class="px-2"
              >
                <v-select
                  :items="orderStatusList"
                  v-model="formData.status_id_fk"
                  :error-messages="errors.collect('Status')"
                  data-vv-name="Status"
                  :label="$t('columns.status') + '*'"
                  v-validate="'required'"
                />
              </v-flex>

              <v-flex
                xs12
                sm6
                md6
                class="px-2"
              >
                <v-text-field
                  :label="$t('columns.quantity') + '*'"
                  v-model="formData.quantity"
                  :error-messages="errors.collect('quantity')"
                  v-validate="'required|numeric|min_value:1'"
                  data-vv-name="quantity"
                >
                </v-text-field>
              </v-flex>

              <v-flex
                xs12
                sm6
                class="px-2"
              >
                <v-text-field
                  :label="$t('columns.weight')"
                  v-model="formData.item_weight"
                  :error-messages="errors.collect('Weight')"
                  v-validate="'required'"
                  data-vv-name="Weight"
                />
              </v-flex>

              <v-flex
                xs12
                sm6
                class="px-2"
              >
                <v-text-field
                  :label="$t('columns.trackNumber')"
                  v-model="formData.track_number"
                  :error-messages="errors.collect('Track Number')"
                  v-validate="'required'"
                  data-vv-name="Track Number"
                />
              </v-flex>

              <v-flex
                xs12
                sm6
                class="px-2"
              >
                <v-text-field
                  :label="$t('columns.orderNumber')"
                  v-model="formData.order_number"
                  :error-messages="errors.collect('Order Number')"
                  v-validate="'required'"
                  data-vv-name="Order Number"
                />
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              style="height:auto"
              @click="closeDialog()"
              outline
              color="normal"
            >{{ $t('common.cancel') }}</v-btn>
            <v-btn
              type="submit"
              :loading="loading"
              style="height:auto" class="submit-btn-spacing"
              outline
              color="success"
            >
              {{ $t('common.save') }}
            </v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Axios from 'axios'
import swal from 'sweetalert'

export default {
  props: [
    'convertToOrderModal',
    'formData',
    'customers',
    'warehouses'
  ],

  data() {
    return {
      loading: false,
      orderStatusList: [
        { text: this.$t('columns.shipment'), value: 8 },
        { text: this.$t('orders.deliveredToErbilOption'), value: 9 }
      ]
    }
  },

  methods: {
    closeDialog() {
      this.$validator.reset()
      this.$emit('close')
    },

    submitForm() {
      let token = localStorage.getItem('access_token')

      this.$validator.validateAll().then((res) => {
        if (res) {
          Axios.post(`api/not-found-order/${this.formData.not_found_order_id}/convert-to-order`, this.formData, {
            headers: { Authorization: 'Bearer ' + token }
          })
            .then(() => {
              swal({
                title: this.$t('orders.addedTitle'),
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              })
              this.$emit('resetTable')
              this.closeDialog()
            })
            .catch(error => {
              swal(this.$t('common.error'), `${error.response.data.message}`, 'error')
            })
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/notFoundOrder/convertToOrder.vue